import UUIDBase from '../UUIDBase'
import { useI18nInstance, localizeFieldName } from '@/plugins/i18n'
import User from "@/models/user/User";

const { t } = useI18nInstance().global

export const commissionI18nMessages = {
    en: {
        commissionInfo: 'Commission Info',
        name: 'Name',
        stores: 'Store(s)',
        employees: 'Employees',
        rules: 'Rules',
        addRule: 'Add Rule',
        all: 'All',
        category: 'Category',
        tag: 'Tag',
        item: 'Item',
        specific: 'Specific',
        amount: 'Amount',
        percentage: 'Percentage',
        period: 'Period',
        open: 'Open',
        specificDate: 'Specific Date',
        from: 'From',
        to: 'To',
        disabled: 'Disabled',
        brand: 'Brand',
        user: 'Created By',
    },
    ar: {
        commissionInfo: 'معلومات العمولة',
        name: 'الاسم',
        stores: 'المتجر',
        employees: 'الموظفين',
        rules: 'القواعد',
        addRule: 'اضافة قاعدة',
        all: 'الجميع',
        category: 'مجموعة',
        tag: 'فئة',
        item: 'منتج',
        specific: 'مخصص',
        amount: 'كمية',
        percentage: 'نسبة',
        period: 'فترة',
        open: 'مفتوح',
        specificDate: 'تاريخ محدد',
        from: 'من',
        to: 'الى',
        disabled: 'معطل',
        brand: 'العلامة التجارية',
        user: 'تم إنشاؤه بواسطة',
    }
}


export class CommissionRule {
    ruleType = ''
    values?: Array<string>
    includeAll = false;
    commissionType = ''
    commissionValue = 0
    order = 0
    static from(json: Record<string, unknown> | CommissionRule) {
        return Object.assign(new CommissionRule(), json)
    }
}

export default class Commission extends UUIDBase {
    static ENDPOINT = '/hr/commissions'

    name = ''
    stores?: Array<string>
    includeAllStores = false
    rules?: Array<CommissionRule>
    employees?: Array<string>
    includeAllEmployees = false
    period = 'open'
    fromDate?: string
    toDate?: string
    disabled: boolean = false;
    userID = ''
    user?: User

    static from(json: Record<string, unknown> | Commission) {
        const commission = Object.assign(new Commission(), json);
        if (json.rules) {
            commission.rules = json.rules.map(i => CommissionRule.from(i));
        }

        if (json.user) json.user = User.from(json.user)

        return commission
    }
}
